function ApplicationError(code,info, message, fileName, lineNumber) {
  var instance = new Error(message, fileName, lineNumber);
  instance.name = 'ApplicationError';
  instance.code = code;
  instance.info = info;
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, ApplicationError);
  }
  return instance;
}

ApplicationError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});

if (Object.setPrototypeOf){
  Object.setPrototypeOf(ApplicationError, Error);
} else {
    ApplicationError.__proto__ = Error;
}

export default ApplicationError;